import React from 'react';

export default function UserResources() {
  return <div>user Resources list form</div>;
}
